import React, {useEffect, useRef, useState} from "react";
import {Tooltip} from "@mui/material";
import { arrowSxDefault, tooltipSxDefault } from "./Styles";
/**
 * @Author: Cecilia López Martínez
 * @Job Title: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 *
 * @Description: Component for displaying a section with a title and its corresponding value.
 *
 * @param {string} title - The section title (required).
 * @param {string|null} value - The section value (optional, defaults to null).
 * @param {JSX.Element} html - Additional JSX content to render (optional, defaults to an empty fragment).
 * @param {string} tooltip - Tooltip text for additional information (optional).
 * @param {string} className - Custom class styles (optional).
 * @param {JSX.Element|null} [icon=null] - Optional icon to display next to the title (optional).
 *
 * @returns {JSX.Element} A component displaying the provided title, value, and optional content.
 */
const RowCardText = ({title , value=null, html=<></>, tooltip='', className = '', icon= null}) => {
    const elementRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
        if (elementRef.current) {
            const spanElement = elementRef.current;
            if (spanElement) {
                setIsTruncated(spanElement.scrollWidth > spanElement.clientWidth);
            }
        }
    }, [value]);

    return (
        <div className={`emp_card_content w-100 ${className}`}>
            <div className="d-flex gap-2 align-items-center">
            {icon && icon}
            <p className="text-capitalize">{title}</p>
            </div>
            {value != null &&
                ((isTruncated && tooltip) ?
                        <Tooltip
                            title={tooltip}
                            placement="top"
                            componentsProps={{
                                tooltip: { sx: tooltipSxDefault },
                                arrow: { sx: arrowSxDefault },
                            }}
                            className={`cursor-pointer`}
                        >
                            <span ref={elementRef} className={'d-inline-block text-truncate ps-3 employee card-subtitle'}>{value}</span>
                        </Tooltip>
                    :
                    <span ref={elementRef} className={'d-inline-block text-truncate ps-3 employee card-subtitle'}>{value}</span>
                )}
            {html}
        </div> )
}

export default RowCardText
